import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { buildQuery } from "../../../utils/buildQuery";

export const ShelfMovementApi = createApi({
	reducerPath: "ShelfMovementReport",
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_BACKEND2_URL}/v1`,
		credentials: "include", // Applies to all requests
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			headers.set("Accept", "application/json");
			return headers;
		},
	}),
	endpoints: (builder) => ({
		getShelfMovementDailySummary: builder.query({
			query: (params) => {
				const query = buildQuery(params);
				return `/shelf-movement/daily-summary${query}`;
			},
		}),
		getShelfMovementDailyDetails: builder.query({
			query: (params) => {
				const query = buildQuery(params);
				return `/shelf-movement/day-details${query}`;
			},
		}),
		getShelfMovementReportExcel: builder.query({
			query: (params) => ({
				url: `/shelf-movement/export${buildQuery(params)}`,
				responseHandler: (response) => response.blob(),
			}),
		}),
		getShelfMovementReportPdf: builder.query({
			query: (params) => ({
				url: `/shelf-movement/export${buildQuery(params)}`,
				responseHandler: (response) => response.blob(),
			}),
		}),
	}),
});

export const {
	useLazyGetShelfMovementDailyDetailsQuery,
	useLazyGetShelfMovementDailySummaryQuery,
	useLazyGetShelfMovementReportExcelQuery,
	useLazyGetShelfMovementReportPdfQuery,
} = ShelfMovementApi;
